export const convertSpwToState = (spwObject) => {
  let stateObj = { ...spwObject };
  try {
    if (spwObject.note1 == '') throw new Error('note1 was empty');
    let note1 = JSON.parse(spwObject.note1);
    stateObj = { ...stateObj, ...note1 };
  } catch (e) { //note1 is a string
    stateObj.memo1_before = spwObject.note1;
    stateObj.memo1_after = '';
    stateObj.memo2_before = '';
    stateObj.memo2_after = '';
  }
  try {
    if (spwObject.note2 == '') throw new Error('note2 was empty');
    let note2 = JSON.parse(spwObject.note2);
    stateObj = { ...stateObj, ...note2 };
  } catch (e) { //note2 is a string
    stateObj.description = spwObject.note2;
    stateObj.other = '';
  }
  return stateObj;
};